import invoiceType from '../../constants-v2/bookkeeping/invoice-type';
import { INVOICE_FILTERS } from './invoiceFilters';
import FiltersType from './listingFiltersTypesConstants';

const filters = [
  ...INVOICE_FILTERS,
  {
    key: '_number_of_days_due',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Ilość dni zaległości:',
    testName: 'test_filter_invoice_number_of_days_due',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'number',
  },
  {
    key: '_number_of_unpaid_invoices',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Ilość nieopłaconych faktur:',
    testName: 'test_filter_invoice_number_of_unpaid_invoices_by_kontrahent',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'number',
  },
  {
    key: '_invoicetype_multi',
    getItems: async () => [
      { value: invoiceType.VAT, label: 'FAKTURA VAT' },
      { value: invoiceType.CORRECTION, label: 'FAKTURA KORYGUJĄCA' },
      { value: invoiceType.CURRENCY, label: 'FAKTURA WALUTOWA' },
      { value: invoiceType.CURRENCY_CORRECTION, label: 'KOREKTA FAKTURY WALUTOWEJ' },
      { value: invoiceType.ADVANCED, label: 'FAKTURA ZALICZKOWA' },
      { value: invoiceType.ADVANCE_CORRECTION, label: 'KOREKTA FAKTURY ZALICZKOWEJ' },
      { value: invoiceType.FINAL, label: 'FAKTURA KOŃCOWA' },
      { value: invoiceType.PROFORMA, label: 'PROFORMA' },
      { value: invoiceType.KLA, label: 'FAKTURA KLA' },
    ],
    reset: async () => null,
    placeholder: 'Rodzaj faktury',
    badge: 'Rodzaj faktury:',
    testName: 'test_filter_invoice_type',
    inputType: FiltersType.MULTI_SELECT_TYPE,
  },
  {
    key: '_invoice_payment_due_status',
    getItems: async () => [
      { value: 'W terminie płatności', label: 'W terminie płatności' },
      { value: 'Częściowo', label: 'Niedopłata' },
      { value: 'Zaległość', label: 'Zaległość' }
    ],
    reset: async () => null,
    placeholder: 'Status płatności',
    badge: 'Status płatności:',
    testName: 'test_filter_invoice_payment_due_status',
    inputType: FiltersType.MULTI_SELECT_TYPE,
  },
  // Dwa poniższe filtry ustawia kliknięcie kategorii należności w podsumowaniu (PUB-1627):
  // „Zapłacone częściowo" / „Nadpłaty" oraz zakres manualne / automatyczne. Muszą być widoczne
  // jako badge i możliwe do wyczyszczenia.
  {
    key: '_invoice_paid_status_multi',
    getItems: async () => [
      { value: 'Nieopłacone', label: 'Nieopłacone' },
      { value: 'Częściowo', label: 'Częściowo' },
      { value: 'Nadpłata', label: 'Nadpłata' },
    ],
    reset: async () => null,
    placeholder: 'Status rozliczenia',
    badge: 'Status rozliczenia:',
    testName: 'test_filter_invoice_settlement_status',
    inputType: FiltersType.MULTI_SELECT_TYPE,
  },
  {
    key: '_invoice_type',
    getItems: async () => [
      { value: 'manual', label: 'Manualne' },
      { value: 'automatic', label: 'Automatyczne' },
    ],
    reset: async () => null,
    placeholder: 'Faktury manualne / automatyczne',
    badge: 'Faktury:',
    testName: 'test_filter_invoice_origin',
    inputType: FiltersType.SELECT_TYPE,
  },
];
export const INVOICE_PAYMENT_DUE_FILTERS = {
  path: '/invoices/payment-due',
  filters,
};
